import { mergeWith, isNull } from 'lodash-es'

export const mergeDefaults = (values: object, defaultValues: object) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const customizer = (defaultValue: any, value: any) => (isNull(value) ? defaultValue : value)

  return mergeWith({ ...defaultValues }, values, customizer)
}
